import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/atoms/Accordion";
import { DataType } from "./DonutChart.type";


export const CustomLegend = ({ data, colors }: { data: DataType[], colors: string[] }) => (
    <Accordion type="single" collapsible className='w-full px-6'>
        <AccordionItem value="item-1">
            <AccordionTrigger className='pt-0'>Leyendas</AccordionTrigger>
            <AccordionContent>
                <ul className="flex flex-col items-start space-y-2 p-4 border rounded-md min-h-[150px] max-h-[150px] overflow-y-auto">
                    {data.map((entry, index) => (
                        <li key={`item-${index}`} className="flex items-start space-x-2">
                            <span
                                className="mt-1 w-3 h-3 rounded-full"
                                style={{ backgroundColor: colors[index % colors.length] }}
                            />
                            <div className="text-sm">
                                <div>{entry.name}</div>
                                <div className="text-xs text-gray-500 dark:text-gray-400">
                                    {entry.value.toLocaleString()}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </AccordionContent>
        </AccordionItem>
    </Accordion>
);